import { clean } from 'common/helpers/object';

const TOKEN_KEY = 'auth-token';
const API_ROUTE = '/api';

/**
 * Get API token
 */
function getToken() {
    return sessionStorage.getItem(TOKEN_KEY);
}

/**
 * Default headers for requests
 */
function getDefaultHeaders() {
    return {
        pragma: 'no-cache',
        Authorization: getToken()
    };
}

/**
 * Convert object with parameters to URL query string
 * @param {Object} params
 */
function buildQuery(params = {}) {
    // Filter empty objects, values
    let queryParams = Object.keys(params).filter((k) => {
        if (params[k] && typeof params[k] === 'object') {
            return !!Object.values(params[k]).length;
        }

        return params[k] != null;
    });

    // Convert object to string
    queryParams = queryParams.map((k) => {
        const value = params[k] && typeof params[k] === 'object' ? JSON.stringify(params[k]) : params[k];

        return `${encodeURIComponent(k)}=${encodeURIComponent(value)}`;
    });

    // Join strings of query parameters by "&"
    queryParams = queryParams.join('&');

    return queryParams;
}

/**
 * Extract data from response
 * @param {Response} response
 */
async function processGetItemsResponse(response) {
    let body = {};

    let contentType = response.headers.get('content-type');

    if (contentType && contentType.includes('application/json')) {
        body = await response.json();

        // If body is array convert it to object
        if (Array.isArray(body)) {
            body = {
                items: body,
                count: +response.headers.get('X-Total-Count')
            };
        }
    }

    return body;
}

/**
 * Prepare complete route
 * @param  {String} routeBase=''    Route base
 * @param  {Object} queryParams     Additional query string parameters
 * @param  {Boolean} ignoreEmptyValues=false    ignore check to remove empty & null values from nested object
 */
export function prepareRoute(routeBase = '', queryParams, ignoreEmptyValues = false) {
    // Convert to URL query string
    let queryString = '';
    // Process query params
    if (queryParams) queryString = buildQuery(ignoreEmptyValues ? queryParams : clean(queryParams));

    return `${API_ROUTE}${routeBase}${queryString ? `?${queryString}` : ''}`;
}

/**
 * Method to fetch data from server API
 * @param {String} route            Part of route string to identify API endpoint
 * @param {Object} params    All request parameters
 */
export async function request(route, params = {}) {
    let { method, body, headers } = {
        // Default values
        headers: {
            ...getDefaultHeaders(),
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        method: 'GET',
        ...params
    };

    let response = await fetch(route, {
        method,
        headers,
        ...(body && { body: JSON.stringify(body) })
    });

    // Process result
    switch (response.status) {
        case 200:
            return await processGetItemsResponse(response);

        case 204:
            // TODO :: Add response in case of error
            return true;

        default: {
            // Create error from response status text
            let error = {
                message: response.statusText,
                statusCode: response.status
            };

            // Get content
            const bodyContent = await response.json();

            if (typeof bodyContent.error !== 'undefined' && bodyContent.error !== undefined) {
                error = bodyContent.error;
            }

            throw error;
        }
    }
}
